module.exports = __webpack_public_path__ + "static/media/stephanie-krist.de943a29.jpg";